<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col cols="12">
          <h3 class="ml-1 mb-2">
            الفلاتر
          </h3>
        </b-col>

        <b-col cols="4">
          <b-form-input
            v-model="filter.search"
            placeholder="Search name or email"
          />
        </b-col>
        <b-col cols="4">
          <v-select
            v-model="filter.status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="status_data"
            class="w-100 mb-0"
            :reduce="(val) => val"
            placeholder="Status"
            :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_local : option.name }}
            </template>
            <template #selected-option="{ name, name_local }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                <strong v-else>{{ name }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
      </b-row>

    </b-card>
    <b-card class="w-100 d-flex rounded-lg">
      <b-row>
        <b-col
          md="12"
          class="pb-2 w-100 d-flex justify-content-between"
        >
          <h3 class="ml-1 mb-2">
            العملاء
          </h3>
          <b-link
            v-if="hasPermission('create users')"
            class="btn btn-primary rounded-pill pt-1 ml-auto "
            to="add_customer"
          >
            عميل جديد
          </b-link>

        </b-col>
      </b-row>

      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <div v-else>
        <b-table
          :items="items.data"
          :fields="fields"
          striped
          responsive
        >
          <template #filter />

          <template #cell(avatar)="data">
            <b-avatar :src="data.item.avatar" />
          </template>

          <template #cell(gl_account)="data">
            <span :class="{ 'text-muted small': glAccountListText(data.item).quiet }">
              {{ glAccountListText(data.item).text }}
            </span>
          </template>

          <template #cell(Actions)="data">
            <div
              v-if="filter.status != 'deleted'"
              class="d-flex align-items-center"
            >
              <b-link
                v-if="hasPermission('view customers')"
                :to="{ name: 'customerDetails', params: { id: data.item.id } }"
              >
                <feather-icon
                  icon="EyeIcon"
                  class="text-info mr-1 "
                  size="20"
                />
              </b-link>
              <b-link
                v-if="hasPermission('edit customers')"
                :to="{ name: 'edit_customer', params: { id: data.item.id } }"
              >
                <feather-icon
                  icon="EditIcon"
                  class="text-muted mr-1 "
                  size="20"
                />
              </b-link>
              <feather-icon
                v-if="hasPermission('delete customers')"
                icon="TrashIcon"
                class="text-danger mr-1 "
                size="20"
                @click="confirmDeleteCustomer(data.item)"
              />

            </div>
            <div
              v-if="filter.status == 'deleted'"
              class="d-flex align-items-center"
            >

              <feather-icon
                v-b-tooltip.hover.top="'حذف العميل بشكل نهائي'"
                icon="TrashIcon"
                class="text-danger mr-1 "
                size="20"
                @click="confirmForceDeleteCustomer(data.item)"
              />
              <feather-icon
                v-b-tooltip.hover.top="'استعادة العميل'"
                icon="RefreshCwIcon"
                class="text-success mr-1 "
                size="20"
                @click="confirmRestoreCustomer(data.item)"
              />
            </div>
          </template>
        </b-table>

        <b-pagination
          v-model="items.meta.current_page"
          align="center"
          :total-rows="items.meta.total"
          :per-page="items.meta.per_page"
          @change="onPageChange"
        />
      </div>
      <add-customer
        v-if="editCustomerModal"
        :customer-id="editingCustomerId"
        @cancel="closeEditModal"
        @created="refreshData"
        @update="refreshData"
      />
    </b-card>

  </div>
</template>

<script>
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  BLink,
  VBTooltip,
  BSpinner,
  BPagination,
  BFormInput,
  BInputGroup,
  BForm,
  BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, phone, national_id,
} from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { glAccountListText } from '@/utils/ledger'
import AddCustomer from './AddCustomer.vue'

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    FeatherIcon,
    AddCustomer,
  },
  computed: {
    ...mapGetters({
      items: 'customers/customers',
      load: 'customers/load',
    }),

  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {

    'filter.search': function (newVal) {
      newVal == '' ? this.filter.search = null : this.filter.search = newVal
      this.$store.dispatch('customers/listCustomers', { query: this.filter, page: 1 })
    },
    'filter.status': function (newVal) {
      this.$store.dispatch('customers/listCustomers', { query: { ...this.filter, status: newVal, page: 1 } })
    },
  },
  data() {
    return {
      checkboxStatus: {},
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      checked: true,
      addNewUserModal: false,
      filter: {
        school_id: null,
        type_id: null,
        status: null,
        search: null,
      },
      status_data: [
        'active',
        'inactive',
        'suspended',
        'deleted',
      ],
      fields: [
        // "show_details",
        // { key: "avatar", label: "Avatar" },
        { key: 'name', label: 'الاسم', sortable: true },
        { key: 'email', label: 'الايميل', sortable: true },
        { key: 'phone', label: 'الهاتف' },
        { key: 'national_id', label: 'الرقم القومي' },
        { key: 'status', label: 'الحالة' },
        { key: 'gl_account', label: 'حساب الدفتر' },
        'Actions',
      ],
      editCustomerModal: false,
      editingCustomerId: null,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    confirmDeleteCustomer(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف العميل بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteCustomer(item.id)
        }
      })
    },

    confirmForceDeleteCustomer(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف العميل بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.forceDeleteCustomer(item.id)
        }
      })
    },
    forceDeleteCustomer(id) {
      this.$store.dispatch('customers/forceDelete', { id })
        .then(() => {
          this.$swal('تم الحذف!', 'تم حذف العميل.', 'success')
          this.refreshData()
        })
        .catch(err => {
          this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
        })
    },
    confirmRestoreCustomer(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم استعادة العميل!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'نعم، استعادة!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.restoreCustomer(item.id)
        }
      })
    },
    restoreCustomer(id) {
      this.$store.dispatch('customers/restore', { id })
        .then(() => {
          this.$swal('تم الاستعادة!', 'تم استعادة العميل.', 'success')
          this.refreshData()
        })
        .catch(err => {
          this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الاستعادة', 'error')
        })
    },
    glAccountListText,
    onPageChange(page) {
      this.$store.dispatch('customers/listCustomers', { query: { ...this.filter, page } })
    },
    refreshData() {
      this.$store.dispatch('customers/listCustomers', { query: { ...this.filter, page: this.items.current_page } })
    },
    init() {
      this.$store.dispatch('customers/listCustomers', { query: { ...this.filter, page: 1 } })
    },
    openEditModal(item) {
      this.editingCustomerId = item.id
      this.editCustomerModal = true
    },
    closeEditModal() {
      this.editingCustomerId = null
      this.editCustomerModal = false
    },
    confirmDeleteCustomer(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف العميل بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteCustomer(item.id)
        }
      })
    },
    deleteCustomer(id) {
      console.log('id', id)

      this.$store.dispatch('customers/deleteCustomer', { id })
        .then(() => {
          this.$swal('تم الحذف!', 'تم حذف العميل.', 'success')
          this.refreshData()
        })
        .catch(err => {
          this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
        })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
